import { useEffect, useState } from "react";
import { Mail, Phone, User } from "lucide-react";
import api from "../../lib/api";

export default function AdminCustomers() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/admin/customers")
            .then((r) => setItems(Array.isArray(r.data) ? r.data : []))
            .catch(() => setItems([]))
            .finally(() => setLoading(false));
    }, []);

    const totalRevenue = items.reduce((s, c) => s + (c.total_spent || 0), 0);
    const totalOrders = items.reduce((s, c) => s + (c.order_count || 0), 0);

    return (
        <div data-testid="admin-customers">
            <div className="mb-6">
                <h2 className="font-display text-3xl">Customers</h2>
                <p className="text-sm text-ink-soft mt-1">Registered customer accounts and their order history.</p>
            </div>

            {!loading && items.length > 0 && (
                <div className="grid grid-cols-3 gap-3 mb-6">
                    <Stat label="Customers" value={items.length} />
                    <Stat label="Orders placed" value={totalOrders} />
                    <Stat label="Revenue (AUD)" value={`$${totalRevenue.toFixed(2)}`} />
                </div>
            )}

            {loading && <p className="text-center text-ink-soft py-10">Loading…</p>}

            <div className="space-y-2">
                {items.map((c, i) => (
                    <div key={c.id} className="bg-white border border-[#EAE3DE] p-4 flex items-center gap-4" data-testid={`customer-row-${i}`}>
                        <div className="w-10 h-10 rounded-full bg-blush-pale flex items-center justify-center shrink-0">
                            <User size={16} className="text-blush" />
                        </div>
                        <div className="flex-1 min-w-0">
                            <p className="font-display text-lg truncate">{c.name}</p>
                            <div className="flex flex-wrap gap-x-4 gap-y-1 text-xs text-ink-soft">
                                <a href={`mailto:${c.email}`} className="inline-flex items-center gap-1 hover:text-blush">
                                    <Mail size={11} /> {c.email}
                                </a>
                                {c.phone && (
                                    <a href={`tel:${c.phone}`} className="inline-flex items-center gap-1 hover:text-blush">
                                        <Phone size={11} /> {c.phone}
                                    </a>
                                )}
                                <span>Joined {new Date(c.created_at).toLocaleDateString("en-AU")}</span>
                            </div>
                        </div>
                        <div className="text-right shrink-0">
                            <p className="font-display text-lg">${(c.total_spent || 0).toFixed(2)}</p>
                            <p className="text-[10px] tracking-[0.2em] uppercase text-ink-soft">
                                {c.order_count || 0} order{c.order_count === 1 ? "" : "s"}
                            </p>
                        </div>
                    </div>
                ))}
                {!loading && items.length === 0 && (
                    <p className="text-center text-ink-soft py-12">No customer accounts yet.</p>
                )}
            </div>
        </div>
    );
}

function Stat({ label, value }) {
    return (
        <div className="bg-white border border-[#EAE3DE] p-4">
            <p className="text-[10px] tracking-[0.3em] uppercase text-ink-soft mb-1">{label}</p>
            <p className="font-display text-2xl">{value}</p>
        </div>
    );
}
